import { ReactElement, ReactNode } from 'react';
import './PageTypes.scss';
export const PageWithSidebar = ({ children }: { children: ReactNode }): ReactElement => (
  <div className="page-with-sidebar">{children}</div>
);
